import React from 'react';
import './PayBills.css';
import payBillsImage from '../images/pay-bills-image.png';

const PayBills = () => {
    return (
        <section className="pay-bills">
            <div className="pay-bills-container">
                <div className="pay-bills-content">
                    <h2>Pay your bills with crypto</h2>
                    <p>Make bill payments on everything from credit cards to mortgages, all with the convenience and smooth experience that only blockchain payments can provide.</p>
                    <div className="icon-buttons">
                        {/* Icons will go here */}
                    </div>
                    <div className="action-buttons">
                        <button>Get the Psyche Gate App to Start</button>
                        <button className="secondary">Pay Bills on Web</button>
                    </div>
                </div>
                <div className="pay-bills-image">
                    <img src={payBillsImage} alt="Pay Bills" />
                </div>
            </div>
        </section>
    );
};

export default PayBills;